module.exports = "https://static.energy5.com/_next/static/images/charger-657ac48b1c9ddfc3e17c8d982950ffe3.png";